import ServiceCard from "./ServiceCard";
import {
    CAROTARE_A,
    CAROTARE_B,
    DEMOLARI_A,
    DEMOLARI_B,
    SLEFUIRE_A,
    SLEFUIRE_B,
    REPASTILARE_A,
    REPASTILARE_B,
} from "@/constants/images";

const SERVICES = [
    {
        title: "CAROTARE",
        desc: "Carotări de înaltă precizie în beton armat pentru instalații sanitare, termice și de ventilație.",
        tag: "BETON ARMAT",
        href: "/carotare",
        base: CAROTARE_A,
        action: CAROTARE_B,
        testid: "service-card-carotare",
    },
    {
        title: "DEMOLĂRI / TĂIERI",
        desc: "Tăieri cu disc diamantat pentru pereți, grinzi și placi din beton armat, fără vibrații.",
        tag: "DISC DIAMANTAT",
        href: "/demolari-taiere",
        base: DEMOLARI_A,
        action: DEMOLARI_B,
        testid: "service-card-demolari",
    },
    {
        title: "ȘLEFUIRE",
        desc: "Pregătirea și finisarea suprafețelor de beton cu scule diamantate de ultimă generație.",
        tag: "SUPRAFEȚE FINITE",
        href: "/slefuire",
        base: SLEFUIRE_A,
        action: SLEFUIRE_B,
        testid: "service-card-slefuire",
    },
    {
        title: "REPASTILARE CAROTE",
        desc: "Restaurarea coroanelor carotelor prin montarea de segmente diamantate noi, cu lipire specială.",
        tag: "SEGMENTE DIAMANTATE",
        href: "/repastilare-carote",
        base: REPASTILARE_A,
        action: REPASTILARE_B,
        testid: "service-card-repastilare",
    },
];

export default function ServicesSection() {
    return (
        <section id="servicii" className="relative pb-16 pt-10 lg:pb-24 lg:pt-14">
            <div className="mx-auto max-w-[1600px] px-5 lg:px-10">
                <div className="mb-10 flex items-end justify-between border-b border-line pb-6 lg:mb-12">
                    <div className="flex items-center gap-4">
                        <span className="h-[2px] w-10 bg-flame" />
                        <h2 className="font-mono-tech text-[11px] font-bold tracking-[0.3em] text-paper">
                            SERVICII — 01/04
                        </h2>
                    </div>
                    <p className="hidden font-mono-tech text-[10px] tracking-[0.25em] text-mist md:block">
                        [ HOVER — VEZI PROCESUL ]
                    </p>
                </div>

                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:gap-5">
                    {SERVICES.map((s, i) => (
                        <ServiceCard key={s.href} index={i} {...s} />
                    ))}
                </div>
            </div>
        </section>
    );
}